/**
 * Get top offset of an element (including offsets of all of parent elements)
 */
export function domGetOffsetTop(element: HTMLElement): number {
  let parentElement = element;
  let offset = 0;

  do {
    // Increase our distance counter
    offset += parentElement.offsetTop;

    // Set the element to it's parent
    parentElement = <HTMLElement>parentElement.offsetParent;
  } while (parentElement);

  return Math.ceil(offset);
}
